module.exports = __webpack_public_path__ + "static/media/sobre-anage-select.529c6f53.jpg";